import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

/**
 * Top-of-transcript scroll-back affordance: the sentinel that asks for the previous page when it
 * scrolls into view, and the row that says a page is on its way (LAT-952).
 *
 * Rendered only while there is something to load, so an exhausted thread carries no extra row —
 * and the observer disconnects with the element, which is what stops it firing at the top of the
 * conversation.
 */
export function AssistantTranscriptScrollBackRow({
  sentinelRef,
  canLoadMore,
  isLoading,
  compact = false,
}: {
  sentinelRef: (node: HTMLElement | null) => void;
  canLoadMore: boolean;
  isLoading: boolean;
  compact?: boolean;
}) {
  if (!canLoadMore && !isLoading) {
    return null;
  }

  return (
    <div
      ref={sentinelRef}
      data-testid="claudia-transcript-scroll-back"
      className={cn(
        "flex w-full shrink-0 items-center justify-center gap-2 text-muted-foreground",
        compact ? "text-[11px]" : "text-xs",
        isLoading ? "py-1" : "h-px"
      )}
    >
      {isLoading ? (
        <>
          <Spinner className={compact ? "size-3" : "size-3.5"} />
          <span>Loading earlier messages</span>
        </>
      ) : null}
    </div>
  );
}
